<template>
    <div class="" :value="value" v-show="showPop">
      <van-dialog
        v-model="showPop"
        show-cancel-button
        confirmButtonText="保存"
        @confirm="add"
      >
        <van-cell-group>
          <van-cell title="日期" is-link arrow-direction="down" :value="activeDate" @click="showDateTime=!showDateTime"/>
          <van-cell title="开始时间" is-link arrow-direction="down" :value="time1" @click="showTime1=!showTime1"/>
          <van-cell title="结束时间" is-link arrow-direction="down" :value="time2" @click="showTime2=!showTime2"/>
          <van-cell title="活动内容">
            <van-field  type="textarea" placeholder="请输入活动内容" class="item2" v-model="liucheng.U_Details"  @input="limitLength(1000,'liucheng','U_Details')"/>
          </van-cell>
        </van-cell-group>
      </van-dialog>
      <van-popup v-model="showDateTime" position="bottom" @click-overlay="showDateTime=!showDateTime">
        <van-datetime-picker
          :min-date="new Date(minDate)"
          :max-date="new Date(maxDate)"
          type="date"
          @confirm="getDate"
          :value="new Date()"
          @cancel="showDateTime=!showDateTime"
        />
      </van-popup>
      <van-popup v-model="showTime1" position="bottom" >
        <van-datetime-picker
          v-if="showPop"
          type="time"
          :min-hour="6"
          :max-hour="22"
          @confirm="getTime1"
          @cancel="showTime1=!showTime1"
        />
      </van-popup>
      <van-popup v-model="showTime2" position="bottom" >
        <van-datetime-picker
          v-if="showPop"
          type="time"
          :min-hour="6"
          :max-hour="22"
          @confirm="getTime2"
          @cancel="showTime2=!showTime2"
        />
      </van-popup>

    </div>
</template>
<script>
  import moment from 'moment'
    export default{
        data(){
            return {
              liucheng:{
                U_Flow : '',//活动时间，必填
                U_Details : ""//流程内容，必填
              },
              showPop:false,
              showDateTime:false,
              showTime1:false,
              showTime2:false,
              activeDate:'',
              time1:'',
              time2:'',

            }
        },
      props:{
        value:{
          type:Boolean,
          default:false
        },
        obj:{},
        minDate:'',
        maxDate:''
      },
      watch:{
        value(val){
          this.showPop = val
        },
        showPop(val){
          if(!val){
              this. liucheng={
                U_Sort:'',
                U_Flow : '',//活动时间，必填
                U_Details : ""//流程内容，必填
              }
             this.activeDate='',
             this.time1='',
             this.time2=''
          }else  if(this.obj){
            this.liucheng.U_Details=this.obj.U_Details
            this.liucheng.U_Sort=this.obj.U_Sort
            if(this.obj.U_Flow){
              this.activeDate=this.obj.U_Flow.split(' ')[0]
              this.time1=this.obj.U_Flow.split(' ')[1].split('-')[0]
              this.time2=this.obj.U_Flow.split(' ')[1].split('-')[1]
            }

          }
          this.$emit('input',val)
        },
//        obj(){
//            if(this.obj.U_Sort){
//              this.liucheng.U_Details=this.obj.U_Details
//              this.liucheng.U_Sort=this.obj.U_Sort
//              this.activeDate=this.obj.U_Flow.split(' ')[0]
//              this.time1=this.obj.U_Flow.split(' ')[1].split('-')[0]
//              this.time2=this.obj.U_Flow.split(' ')[1].split('-')[1]
//            }
//        }
      },
      methods:{
        getDate(e){
          this.showDateTime=!this.showDateTime
          let  dateTime=moment(e).format('YYYY-MM-DD')
          console.log(dateTime,this.minDate,dateTime<this.minDate)
           if(dateTime<this.minDate){
             this.$title('流程开始日期不得小于活动开始日期')
             return
           }else if(dateTime>this.maxDate){
             this.$title('流程开始日期不得大于活动结束日期')
             return
           }
          this.activeDate= dateTime
        },
        getTime1(e){
          this.showTime1=!this.showTime1
          if(e>this.time2&&this.time2!=''){
              this.$title('开始时间不得大于结束时间')
              return
          }
           this.time1=e
        },
        getTime2(e){
          this.showTime2=!this.showTime2
          if(e<this.time1&&this.time1!=''){
            this.$title('开始时间不得大于结束时间')
            return
          }
          this.time2=e
        },
        add(){
            if(!this.activeDate){
              this.$title('请选择日期')
              return
            }else if(!this.time1){
              this.$title('请选择开始时间')
              return
            }else if(!this.time2){
              this.$title('请选择结束时间')
              return
            } else if(!this.liucheng.U_Details){
              this.$title('请输入流程内容')
              return
            }
          this.liucheng.U_Flow =this.activeDate+' '+this.time1+'-'+this.time2
            this.$emit('newLiucheng',this.liucheng)
        },
        limitLength(len,key1,key2){
          let value = ''
          if(key2){
            value =this.$data[key1][key2]
          }else{
            value =this.$data[key1]
          }
          if(value.length>len){
            if(key2){
              this.$data[key1][key2]=value.slice(0,len)
            }else{
              this.$data[key1]=value.slice(0,len)
            }
          }
        }
      }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/active/component/liuchengPop.vue